import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  Grid,
  Modal,
  ListaEncerramentoExigencias,
} from '../../../components/index';
import {
  doPut,
  requestExigencias,
  requestMotivos,
} from '../../../utils/requests';
import { tiposExigenciaSistema } from '../../../utils/constants';

class ModalEncerramentoExigencia extends Component {
  constructor(props) {
    super(props);
    const state = this.getInitialState();
    if (props.requerimento) {
      state.requerimento = props.requerimento;
    }
    this.state = state;
  }

  getInitialState = () => {
    const initialState = {
      requerimento: {
        exigencias: [],
      },
    };
    return initialState;
  }

  componentDidMount() {
    this.buscaDadosDeDominio();
  }

  componentDidUpdate(prevProps) {
    // Preenche requerimento se requerimento for alterado
    if (this.props.requerimento &&
      this.props.requerimento.protocolo !== prevProps.requerimento.protocolo) {
      this.atualizaRequerimento();
    }
  }

  atualizaRequerimento = () => {
    const { requerimento } = { ...this.props };
    this.setState({ ...this.state, requerimento });
  }

  trataSucessoResponseEnvio = () => {
    this.props.handleEncerramentoExigenciaSent();
  }

  trataErrosResponse = (error) => {
    // eslint-disable-next-line
    const { requerimento } = { ...this.state };
    if (error.data.codigo === 4500) {
      // const colecao = ['showEncerramentoExigenciaModal', 'showModalAlertaRequerPerConcomitancia'];
      const chave = error.data.chaveConfirmacao;
      if (error.data.alertas && error.data.alertas.length > 0) {
        error.data.alertas.forEach((item) => {
          if (item.codigo === 4512) {
            this.props.handleModalComposto('showEncerramentoExigenciaModal', item.descricao, requerimento, chave);
          }
        });
      }
    }
  }

  handleSave = () => {
    const { requerimento } = { ...this.state };
    requerimento.estado = 3;

    let url = `requerimentos-compensacao-pensao/${requerimento.protocolo}`;
    if (requerimento.tipoAposentadoria) {
      url = `requerimentos-compensacao-aposentadoria/${requerimento.protocolo}`;
    }
    doPut(url, requerimento, this.trataSucessoResponseEnvio, this.trataErrosResponse);
  }

  filtraExigencias = () => {
    if (this.props.requerimento.exigencias) {
      return this.props.requerimento.exigencias
        .filter(exigencia => (!tiposExigenciaSistema.includes(exigencia.tipo)));
    }
    return '';
  }

  handlePositionalChange = (changeObj, name, tipoExigencia, codigoDependente) => {
    // console.log(tipoExigencia);
    const listaExigenciasModificada = this.state.requerimento.exigencias.map((exigencia, index) => {
      if (tipoExigencia === exigencia.tipo && (codigoDependente === exigencia.codigoDependente)) {
        const exigenciaAlterada = this.state.requerimento.exigencias[index];
        exigenciaAlterada[name] = changeObj.value;
        let atendida = 0;
        if (exigenciaAlterada.motivoNaoAtendimento !== 0 || exigenciaAlterada.comentarioNaoAtendimento !== '') {
          atendida = 2;
        }
        exigenciaAlterada.atendida = atendida;
        return exigenciaAlterada;
      }
      return this.state.requerimento.exigencias[index];
    });
    this.setState({
      requerimento: {
        ...this.state.requerimento,
        exigencias: listaExigenciasModificada,
      },
    });
  }

  doRequest = (typeRequest) => {
    switch (typeRequest) {
      case 'exigencia':
        if (this.props.exigencias.length === 0) {
          requestExigencias(this.failCallback);
        }
        break;
      case 'motivo':
        if (this.props.motivosNaoCumprimento.length === 0) {
          requestMotivos(this.failCallback);
        }
        break;
      default:
        break;
    }
  }

  buscaDadosDeDominio = () => {
    if (this.props.motivosNaoCumprimento.length === 0) {
      this.doRequest('motivo');
      return null;
    }
    return null;
  }

  retornaTamanhoExigencias = () => {
    let colecao = [];
    if (this.props.requerimento.exigencias) {
      colecao = this.props.requerimento.exigencias
        .filter(exigencia => (!tiposExigenciaSistema.includes(exigencia.tipo)));
    }
    return colecao.length;
  }

  modalEncerramentoExigenciaContent = () => (
    <div className="row">
      <Grid cols="12 12 12 12" style={{ height: this.retornaTamanhoExigencias() > 2 ? '600px' : '300px', overflow: 'auto' }}>
        <ListaEncerramentoExigencias
          exigencias={this.filtraExigencias()}
          motivosNaoCumprimento={this.props.motivosNaoCumprimento}
          handlePositionalChange={this.handlePositionalChange}
        />
      </Grid>
    </div>
  )

  modalEncerramentoExigenciaFooter = () => (
    <React.Fragment>
      <div className="right">
        <Button
          className="dtp-primary"
          hint="Encerrar exigências do requerimento"
          onClick={this.handleSave}
          title="Encerrar exigências"
        />
      </div>
    </React.Fragment>
  )

  handleClose = () => {
    this.props.handleModal('showEncerramentoExigenciaModal');
  }

  render() {
    return (
      <Modal
        {...this.props}
        conteudofooter={this.modalEncerramentoExigenciaFooter()}
        conteudomodal={this.modalEncerramentoExigenciaContent()}
        onHide={this.handleClose}
        size="lg"
        showModal
        title="Exigências não Atendidas"
      />
    );
  }
}

ModalEncerramentoExigencia.propTypes = {
  requerimento: PropTypes.shape({
    exigencias: PropTypes.array,
  }),
  showModal: PropTypes.func,
  handleModal: PropTypes.func,
  handleEncerramentoExigenciaSent: PropTypes.func,
  handleModalComposto: PropTypes.func,
  motivosNaoCumprimento: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
}.isRequired;

const mapStateToProps = state => ({
  motivosNaoCumprimento: state.base.motivosNaoCumprimento,
});

export default connect(mapStateToProps)(ModalEncerramentoExigencia);




// WEBPACK FOOTER //
// ./src/pages/consultas/Exigencia/ModalEncerramentoExigencia.jsx